import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { RestorableFicheDePrep } from '@teetsh/app/src/types/sequences';

export const FDP_TRASH_KEY = 'fdp_trash';

function fetchFichesDePrepTrash() {
  const requestURL = '/fiches-de-prep/trash';
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }: { data: RestorableFicheDePrep[] }) => data || []);
}

export function useFichesDePrepTrash() {
  return useQuery({
    queryKey: [FDP_TRASH_KEY],
    queryFn: () => fetchFichesDePrepTrash(),
    placeholderData: [],
    refetchOnWindowFocus: false,
  });
}
